import { SearchIcon } from '@chakra-ui/icons';
import { Box } from '@chakra-ui/react';
import { components, DropdownIndicatorProps, GroupBase } from 'react-select';

import { DropdownOption } from '../../DropdownInput/typings';

const SearchDropdownIndicator = <
  Option = DropdownOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: DropdownIndicatorProps<Option, IsMulti, Group> & { testId?: string },
) => {
  return (
    <Box data-testid={props.testId || 'search'} height='100%' alignContent={'center'} cursor={'pointer'} width={8}>
      <components.DropdownIndicator {...props}>
        <SearchIcon color='black' />
      </components.DropdownIndicator>
    </Box>
  );
};

export default SearchDropdownIndicator;
